import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  GridItem,
  Text,
  Flex,
  Icon,
  Button,
} from "@chakra-ui/react";
import {
  FaClock,
  FaBook,
  FaRegClock,
  FaSchool,
  FaPrint,
  FaSync,
} from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const StaffTimetable = () => {
  const [timetableData, setTimetableData] = useState([]);
  const [days, setDays] = useState([]);
  const [error, setError] = useState(null);

  // Array of random background colors
  const colors = [
    "red.100",
    "green.100",
    "blue.100",
    "yellow.100",
    "orange.100",
    "purple.100",
  ];

  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const jwtToken = sessionStorage.getItem("jwt");
        const userId = sessionStorage.getItem("user_id");

        const response = await fetch(
          `${BASE_URL}/admin/timetable/list_timetable_to_teacher.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({ pass: userId }), // Send user_id as pass
          }
        );

        const data = await response.json();
        console.log("timblee", data);

        if (data.success) {
          setTimetableData(Array.isArray(data.Timetable) ? data.Timetable : []);
        } else {
          setError(data.message || "Error fetching timetable");
          console.error("Error fetching timetable:", data.message);
        }
      } catch (error) {
        setError("Error fetching timetable");
        console.error("Error fetching timetable:", error);
      }
    };

    const fetchDays = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/day_master.php`
        );
        const data = await response.json();

        if (Array.isArray(data.data)) {
          setDays(data.data);
        } else {
          console.error("Unexpected response format for days:", data);
        }
      } catch (error) {
        console.error("Error fetching days:", error);
      }
    };

    fetchTimetable();
    fetchDays();
  }, []);

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>TimeTable</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md" // Applies a medium shadow
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  // Add refresh functionality here
                  console.log("Refresh button clicked");
                }}
              >
                <FaSync color="#515B73" />
              </Button>

              <div className="export-dropdown">
                <Button
                  className="export-button"
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>
              </div>
            </div>
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Time Table</span>
          </div>
        </div>
        <Box p={6}>
          <Box className="sb" p={4}>
            <Text fontSize="2xl" fontWeight="bold">
              Staff Timetable
            </Text>
          </Box>

          {error && <Text color="red.500">{error}</Text>}
          <Grid
            templateColumns={{
              base: "1fr", // 1 column on mobile
              sm: "repeat(2, 1fr)", // 2 columns on small screens (e.g., small tablets)
              md: "repeat(3, 1fr)", // 3 columns on medium screens (e.g., tablets)
              lg: "repeat(5, 1fr)", // 5 columns on large screens (e.g., laptops/desktops)
            }}
            gap={6}
            mt={1}
            p={4}
            className="sb2"
          >
            {days.length > 0 ? (
              days.map((day, i) => (
                <GridItem key={i}>
                  <Text fontWeight="bold" mb={3}>
                    {day.day}
                  </Text>
                  {timetableData
                    .filter((slot) => slot.day === day.day)
                    .map((slot, j) => (
                      <Box
                        key={j}
                        bg={colors[Math.floor(Math.random() * colors.length)]} // Random color
                        p={{ base: 2, md: 4 }} // Smaller padding for mobile
                        borderRadius="md"
                        mb={4}
                      >
                        <Flex alignItems="center" mb={2}>
                          <Icon as={FaClock} color="gray.500" mr={2} />
                          <Text>
                            {slot.start_time} - {slot.end_time}
                          </Text>
                        </Flex>
                        <Flex alignItems="center" mb={2}>
                          <Icon as={FaBook} color="gray.500" mr={2} />
                          <Text>Subject: {slot.subject}</Text>
                        </Flex>
                        <Flex
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Flex alignItems="center">
                            <Icon as={FaSchool} color="gray.500" mr={2} />
                            <Text>
                              Class: {slot.class}, {slot.division}
                            </Text>
                          </Flex>
                          <Flex alignItems="center">
                            <Icon as={FaRegClock} color="gray.500" mr={2} />
                            <Text>Period: {slot.period}</Text>
                          </Flex>
                        </Flex>
                      </Box>
                    ))}
                </GridItem>
              ))
            ) : (
              <Text>No timetable data available</Text>
            )}
          </Grid>
        </Box>
      </div>
    </Box>
  );
};

export default StaffTimetable;
